import AcademicContext from "./AcademicContext.js";
import AcademicContextProvider from "./AcademicContextProvider";

export default AcademicContext;

export * from "./withAcademicContext";
export { AcademicContextProvider };
